
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35 15.992l-3.882-4.25.541-5.626-5.743-1.254L22.909 0 17.5 2.232 12.09 0 9.085 4.862 3.341 6.1l.54 5.627L0 15.992l3.882 4.25-.541 5.642 5.743 1.254L12.091 32l5.409-2.247 5.41 2.232 3.006-4.862 5.743-1.254-.54-5.626L35 15.993zm-20.682 7.645L7.955 17.52l2.243-2.155 4.12 3.944L24.802 9.235l2.244 2.17-12.728 12.232z","fill":"#21BA45"}})])
          )
        }
      }
    